const appKey = "gfest";
const cdnUrl = "https://site.gcores.com";
const imageUrl = "https://image.gcores.com";

module.exports = {
  appKey,
  cdnUrl,
  imageUrl,
  pageUrl: `${cdnUrl}/${appKey}`,
  appInfo: {
    name: "Gfest 线上游戏联欢会",
    description:
      "「Gfest 线上游戏联欢会」公布，来线上和我们一同聚会。今年没有核聚变，但我们可以在这里先聚一次！",
    shareTitle: "「Gfest 线上游戏联欢会」公布，来线上和我们一同聚会",
    shareDescription: "今年没有核聚变，但我们可以在这里先聚一次！"
  }
};
